import api from 'src/Utils/api';
export var logoutContacts = function () { return api.delete('/contacts/sign_out'); };
export var logoutAdmins = function () { return api.delete('/admin_users/sign_out'); };
